// extracted by mini-css-extract-plugin
export default {"alert":"FormAlert_alert__YA2Wr","danger":"FormAlert_danger__TKwcp","success":"FormAlert_success__65EWE","icon":"FormAlert_icon__VC+f3","text":"FormAlert_text__OLMf6"};